import { useQuery } from '@tanstack/react-query'

import {
  toClientsOverview,
  yearParam,
  type ClientsOverviewWire,
} from '@/features/clients/api/clientWire'
import { api } from '@/lib/api'
import { queryKeys } from '@/lib/query'
import type { ClientsOverview, YearFilter } from '@/types/domain'

/** The clients overview for one year (or every year), composed server-side.
 *  No mock branch: the composer has no showcase fixture, and a page that
 *  runs against the real server in every mode is the point of it. */
export function useClientsOverview(year: YearFilter, search?: string) {
  return useQuery<ClientsOverview>({
    queryKey: queryKeys.directories.clientsOverview(year, search),
    queryFn: async () =>
      toClientsOverview(
        await api.get<ClientsOverviewWire>('/clients/overview', {
          params: { year: yearParam(year), search },
        }),
      ),
  })
}
